import {
  Classes as BlueprintClasses,
  PopoverPosition as BlueprintPopoverPosition,
} from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';

import { InteractiveAvatarProps } from 'bones/design-system/components/avatar/InteractiveAvatar';
import { Tooltip } from 'bones/design-system/components/Tooltip';

export type StaticAvatarProps = Omit<InteractiveAvatarProps, 'onClick'>;

export const StaticAvatar: React.VFC<StaticAvatarProps> = ({
  active,
  className,
  disabled,
  image,
  size,
  testId,
  text,
  tooltip,
  tooltipPosition = BlueprintPopoverPosition.BOTTOM,
}) => (
  <Tooltip
    description={tooltip || ''}
    disabled={!tooltip}
    position={tooltipPosition}
  >
    <div
      className={classNames(
        className,
        BlueprintClasses.BUTTON,
        'vb-avatar',
        `vb-avatar-size--${size}`,
        {
          [BlueprintClasses.ACTIVE]: active,
          [BlueprintClasses.DISABLED]: disabled,
          'vb-avatar--initials': !image,
        }
      )}
      data-testid={testId}
    >
      {image || text}
    </div>
  </Tooltip>
);
